<template>
    <div class="enroll_success_box no-trans" v-loading="loading">
        <el-dialog title="提交成功" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
               <div class="images">
                    <img src="@/assets/img/login/success.png" alt="">
               </div>
               <div class="texts">您的问题已提交至客服，请耐心等待~</div>
                <div class="btn_flex">
                    <div class="bnts1" @click="handle_ck">查看我的问题</div>
                    <div class="bnts2" @click="handle_hf">返回首页</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:false,//显示隐藏
            
           
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
        
        handle_open(){
            this.dialogVisible=true
        },
        handle_hf(){
            this.$router.push({
                path:'/home'
            })
        },
        handle_ck(){
            this.$router.push({
                path:'/user_zx'
            })
        }


    },

}
</script>
<style scoped lang="less">
.enroll_success_box {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 580px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                     .images{
                        text-align: center;
                        img{
                            width: 71px;
                            height: 71px;
                        }
                     }
                     .texts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #999999;
                        padding-top: 20px;
                        text-align: center; 
                     }
                    
                    .btn_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 67px;

                        .bnts1{
                            width: 128px;
                            height: 40px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;

                        }
                        .bnts2{
                            width: 128px;
                            height: 40px;
                            background: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left:20px ;
                        }
                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .enroll_success_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .enroll_success_box.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .enroll_success_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .images img {
        width: 71px;
        height: 71px;
    }
    .enroll_success_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .texts {
        font-size: 18px;
        padding-top: 16px;
    }
    .enroll_success_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .enroll_success_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex .bnts1 {
        width: 128px;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        line-height: 40px;
        font-size: 14px;
    }
    .enroll_success_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex .bnts2 {
        width: 128px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        margin-left: 16px;
    }
}
</style>
